/* globals Stripe */
import config from '../../config';

const instancesPerLocale = new Map();

export const getStripeInstance = (locale = 'en') => {
  if (instancesPerLocale.has(locale)) {
    return instancesPerLocale.get(locale);
  }

  const instance = Stripe(config.stripeKey, { locale });
  instancesPerLocale.set(locale, instance);

  return instance;
};
